var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBadgeStreak = function SvgIconBadgeStreak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_badge_streak_svg__a",
    width: "133.3%",
    height: "133.3%",
    x: "-16.7%",
    y: "-16.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#99C",
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    filter: "url(#icon_badge_streak_svg__a)",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.075 11.74c.462-.006.925-.438.925-.966V6.948c0-.255-.116-.496-.231-.675-.232-.177-.463-.275-.694-.273l-3.818.036c-.462.005-.925.438-.925.966 0 .529.463.952.925.948l1.504-.014-6.362 6.284-3.124-2.732c-.347-.328-.925-.304-1.272.056l-4.743 4.83a1.01 1.01 0 0 0 0 1.351.86.86 0 0 0 1.273-.012l4.164-4.19 3.123 2.729c.347.325.926.303 1.273-.052l7.056-6.948-.116 1.54c0 .529.463.952 1.042.948"
  })))));
};
export default SvgIconBadgeStreak;